import ADPDeptService from "../../../../services/admin/ADPDeptService";
import ADPModuleService from "../../../../services/admin/ADPModuleService";



class moduleService {


    async create(data: any): Promise<any> {
        return await ADPModuleService.create(data);
    }

    async update(moduleId: any, data: any): Promise<any> {
        return await ADPModuleService.update(moduleId, data);
    }

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async findAll(facilityCode: string): Promise<any> {
        return await ADPModuleService.findAll(facilityCode);
    }

    async getDeptDropdown(): Promise<any> {
        return await ADPDeptService.getDropdown();
    }
}

export default new moduleService();